import { ContractModificationType, ContractBusinessLine, ContractModificationStatus } from "../constants/dealer-basic-data";

export class ContractModification {

    id: number = -1;
    type: ContractModificationType = ContractModificationType.CONTRACT_PROPOSE;

    carId: string = ""; 
    businessLines: ContractBusinessLine[];

    notes: string = ""; 
    
    status: ContractModificationStatus = ContractModificationStatus.PROPOSED;

    created: string = ""; 
    createdBy: string = ""; 

    lastUpdated: string = ""; 
    lastUpdatedBy: string = ""; 

    constructor(){
        this.businessLines = [];
    }
 }